<template>
  <div class="referer-report heatmap-report padding_both_sides">
    <div class="referer-report-content__header clearfix">
      <h2>{{ $t('referrers.title') }}</h2>
      <span class="sync-option">
        <label for="sync">{{ $t('referrers.sync') }}</label>
        <ui-switch v-model="isSynced" id="sync"/>
      </span>
    </div>
    <div class="referer-report-content--wrap">
      <div style="float: left; width: 740px; height: 100%; position: relative; margin-right: 60px;">
        <heatmap
          ref="heatmapA"
          mode="compareA"
          :aid="aid"
          :syncedOptions.sync="syncedOptions"
          :userActionData="userActionDataA"
          :isDownloading="isDownloading"
          @onDownloading="onDownloading"
          @onUserActionDataChange="userActionDataA = $event"/>
      </div>
      <div class="line__divide icon--dash-line">
        <span>{{ $t('common.versus') }}</span>
      </div>
      <div style="float: left; width: 740px; height: 100%; position: relative;">
        <heatmap
          ref="heatmapB"
          mode="compareB"
          :aid="aid"
          :syncedOptions.sync="syncedOptions"
          :userActionData="userActionDataB"
          @onDownloading="onDownloading"
          @onUserActionDataChange="userActionDataB = $event"/>
      </div>
    </div>
    <download-error :isDownloading="isDownloading"
                    @onDownloading="onDownloading"></download-error>
  </div>
</template>

<script>
import { getScrollSyncFn } from '@/libs/heatmap-helper'
import Heatmap from '@/components/heatmap'
import DownloadError from '@/components/heatmap/HeatmapDownloadError'
import UiSwitch from '@/components/ui/UiSwitch'

export default {
  name: 'ReferrersReport',
  components: {
    Heatmap,
    UiSwitch,
    DownloadError
  },
  data () {
    return {
      isSynced: false,
      syncedOptions: null,
      userActionDataA: null,
      userActionDataB: null,
      isDownloading: false
    }
  },
  computed: {
    aid () {
      return this.$route.params.aid
    }
  },
  watch: {
    isSynced (value) {
      if (value) {
        this.syncedOptions = {}
        this.bindScrollSyncEvent()
      } else {
        this.syncedOptions = null
        this.unbindScrollSyncEvent()
      }
    }
  },
  beforeDestroy () {
    this.unbindScrollSyncEvent()
  },
  methods: {
    onDownloading (value) {
      this.isDownloading = value
    },
    bindScrollSyncEvent () {
      const containerA = this.$refs.heatmapA.$refs.container
      const containerB = this.$refs.heatmapB.$refs.container
      this.scrollHandler = getScrollSyncFn(containerA, containerB)
      containerA.addEventListener('scroll', this.scrollHandler, false)
      containerB.addEventListener('scroll', this.scrollHandler, false)
    },
    unbindScrollSyncEvent () {
      if (this.scrollHandler) {
        const containerA = this.$refs.heatmapA.$refs.container
        const containerB = this.$refs.heatmapB.$refs.container
        containerA.removeEventListener('scroll', this.scrollHandler)
        containerB.removeEventListener('scroll', this.scrollHandler)
        this.scrollHandler = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.referer-report {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;

  .referer-report-content__header {
    height: 50px;
    margin-top: 30px;

    h2 {
      vertical-align: middle;
      display: inline-block;
      font-size: 22px;
      font-weight: bold;
      color: #444444;
    }
    .sync-option {
      vertical-align: middle;
      position: relative;
      display: inline-block;
      margin-left: 14px;
      font-size: 14px;
      font-weight: bold;
      color: #444;

      &:before {
        display: inline-block;
        content: '';
        width: 1px;
        height: 12px;
        border-left: 1px solid #d7d7d7;
        margin-right: 12px;
        position: relative;
        top: 1px;
      }
      label {
        margin-right: 9px;
      }
    }
  }
  .referer-report-content--wrap {
    position: relative;
    width: 1540px;
    height: calc(100% - 80px);
    .content__heatmap {
      height: 100%;
      padding-right: 30px;
    }
  }
  .line__divide {
    @include positionXYcenter;
    width: 2px;
    height: 100%;
    span {
      position: absolute;
      top: 78px;
      transform: translateX(-50%);
      display: inline-block;
      background-color: #F4F4F1;
      text-align: center;
      padding: 9px 0;
      font-size: 15px;
      font-weight: bold;
      color: #ec0047;
    }
  }
}
.popup__error {
  @include positionXYcenter;
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 50px 30px 25px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;

  .title {
    margin-top: 15px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #444444;
  }

  .desc {
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #2f2f2f;
  }

  .ui-btn {
    margin-top: 60px;
  }
}
</style>
